/**
 * Created by Administrador on 12/12/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('customerCorporateCtrl', customerCorporateCtrl)
        .controller('newCustomerCorporateCtrl', newCustomerCorporateCtrl)
        .controller('editCustomerCorporateCtrl', editCustomerCorporateCtrl)
        .controller('deleteCustomerCorporateCtrl', deleteCustomerCorporateCtrl)
        .controller('baseRateCustomerCorporateCtrl', baseRateCustomerCorporateCtrl)
        .controller('financialStateCustomerCorporateCtrl', financialStateCustomerCorporateCtrl);

    customerCorporateCtrl.$inject = ['customerCorporates', 'linkService'];
    newCustomerCorporateCtrl.$inject = ['linkService','cityService','customerCorporateService','parents','regions'];
    editCustomerCorporateCtrl.$inject = ['linkService','cityService','customerCorporateService','customerCorporate','regions'];
    deleteCustomerCorporateCtrl.$inject = ['linkService','customerCorporateService', 'customerCorporate', '$uibModalInstance'];
    baseRateCustomerCorporateCtrl.$inject = ['linkService','baseRateCorporateService','$stateParams','customerCorporate', 'baseRates'];
    financialStateCustomerCorporateCtrl.$inject = ['linkService','kardexService','customerCorporate'];

    function customerCorporateCtrl(customerCorporates, linkService){
        var vm = this;
        vm.linkService = linkService;
        vm.customerCorporates = (customerCorporates.data._embedded)? customerCorporates.data._embedded.customerCorporates : [];
        vm.customerCorporatesNew = [];
        addingAttributes();
        vm.pages = customerCorporates.data.page;

        function addingAttributes(){
            var parentId = 0;
            var customerCorporateNew = {};
            angular.forEach(vm.customerCorporates, function (customerCorporate,index) {
                /*var parentAuxId = parseInt(vm.linkService.getLinkId((customerCorporate._embedded.customerCorporate?
                    customerCorporate._embedded.customerCorporate._links.self.href:customerCorporate._links.self.href)));*/
                var parentAuxId;
                if(customerCorporate._embedded !== undefined) {
                    if(customerCorporate._embedded.customerCorporate !== undefined) {
                        parentAuxId = parseInt( vm.linkService.getLinkId( customerCorporate._embedded.customerCorporate._links.self.href ) );
                    } else {
                        parentAuxId = parseInt( vm.linkService.getLinkId( customerCorporate._links.self.href ) );
                    }
                } else {
                    parentAuxId = parseInt( vm.linkService.getLinkId( customerCorporate._links.self.href ) );
                }
                if(parentId==0){
                    customerCorporateNew = customerCorporate;
                    customerCorporateNew.children = [];
                    customerCorporateNew.parentId = parentAuxId;
                    customerCorporateNew.hasChildren = customerCorporate._embedded.customerCorporates?true:false;
                    parentId = parentAuxId;
                }else{
                    if(parentId==parentAuxId){
                        customerCorporateNew.children.push(customerCorporate);
                    }else{
                        vm.customerCorporatesNew.push(customerCorporateNew);
                        customerCorporateNew = customerCorporate;
                        customerCorporateNew.children = [];
                        customerCorporateNew.parentId = parentAuxId;
                        //customerCorporateNew.hasChildren = customerCorporate._embedded.customerCorporates?true:false;
                        if(customerCorporate._embedded !== undefined) {
                            customerCorporateNew.hasChildren = customerCorporate._embedded.customerCorporates?true:false;
                        } else {
                            customerCorporateNew.hasChildren = false;
                        }
                        parentId = parentAuxId;
                    }
                }

                if((index+1)==vm.customerCorporates.length){
                    vm.customerCorporatesNew.push(customerCorporateNew);
                }
            });
        }
    }

    function newCustomerCorporateCtrl(linkService,cityService,customerCorporateService,parents,regions){
        var vm = this;
        vm.parents = parents;
        vm.regions = (regions.data._embedded)? regions.data._embedded.regions : [];
        vm.cities = [];
        vm.disableSelects = false;
        vm.selectCheckBox = {};
        vm.customerCorporate = {
            centralOffice:  true,
            centralizedAccount: true,
            prepaid: true,
            phones: [
                {
                    prefix : undefined,
                    number : undefined
                }
            ]
        };

        vm.getCities = function(region){
            vm.cities = getCities(region, cityService, linkService, vm);
        }

        vm.saveCustomerCorporate = function(isValid, customerCorporate){
            if(isValid){
                customerCorporate.originPayment = (vm.selectCheckBox[1]) ? true : false;
                customerCorporate.destinationPayment = (vm.selectCheckBox[2]) ? true : false;
                customerCorporate.regionId = parseInt(linkService.getLinkId(customerCorporate.region._links.self.href));
                customerCorporate.cityId = parseInt(linkService.getLinkId(customerCorporate.city._links.self.href));
                if(customerCorporate.centralOffice){
                    //customerCorporate.parentId = undefined;
                }else{
                    customerCorporate.parentId = parseInt(linkService.getLinkId(customerCorporate.parent._links.self.href));
                    customerCorporate.socialReason = customerCorporate.parent.socialReason,
                    customerCorporate.nit = customerCorporate.parent.nit,
                    customerCorporate.centralizedAccount = customerCorporate.parent.centralizedAccount,
                    customerCorporate.prepaid = customerCorporate.parent.prepaid
                }
                customerCorporate.phone = getPhone(customerCorporate.phones);
                customerCorporateService.saveCustomerCorporate(customerCorporate);
            }
        }

        vm.addPhones = function(){
            vm.customerCorporate.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.customerCorporate.phones.splice(index, 1)
        }
    }

    function editCustomerCorporateCtrl(linkService,cityService,customerCorporateService,customerCorporate,regions){
        var vm = this;
        vm.disableSelects = true;
        vm.linkService = linkService;
        vm.customerCorporate = customerCorporate.data;
        vm.regions = (regions.data._embedded)? regions.data._embedded.regions : [];
        vm.cities = [];
        vm.selectCheckBox = {
            1: vm.customerCorporate.originPayment,
            2: vm.customerCorporate.destinationPayment
        };

        vm.customerCorporate.parent = vm.customerCorporate._embedded.customerCorporate;
        vm.customerCorporate.id = parseInt(linkService.getLinkId(vm.customerCorporate._links.self.href));
        vm.customerCorporate.centralOffice = vm.customerCorporate._embedded.customerCorporate?false:true;
        vm.customerCorporate.region = vm.customerCorporate._embeddeds.city._embedded.region;
        vm.customerCorporate.city = vm.customerCorporate._embeddeds.city;
        vm.customerCorporate.prepaidOriginal = vm.customerCorporate.prepaid;
        vm.customerCorporate.phones = setPhones(vm.customerCorporate.phone);
        getCities(vm.customerCorporate.region, cityService, linkService, vm);

        vm.getCities = function(region){
            vm.cities = getCities(region, cityService, linkService, vm);
        }

        vm.showMessage = function(){
            if(vm.customerCorporate.prepaidOriginal != vm.customerCorporate.prepaid){
                if(vm.customerCorporate._embedded.kardex.balance > 0 && !vm.customerCorporate.prepaidOriginal){
                    vm.viewMessage = true;
                    vm.customerCorporate.prepaid = vm.customerCorporate.prepaidOriginal;
                }
            }
        }

        vm.saveCustomerCorporate = function(isValid, customerCorporate){
            if (isValid) {
                customerCorporate.originPayment = (vm.selectCheckBox[1]) ? true : false;
                customerCorporate.destinationPayment = (vm.selectCheckBox[2]) ? true : false;
                customerCorporate.regionId = parseInt(linkService.getLinkId(customerCorporate.region._links.self.href));
                customerCorporate.cityId = parseInt(linkService.getLinkId(customerCorporate.city._links.self.href));
                customerCorporate.phone = getPhone(customerCorporate.phones);
                customerCorporateService.updateCustomerCorporate(customerCorporate, customerCorporate.id);
            }
        }

        vm.addPhones = function(){
            vm.customerCorporate.phones.push({
                'prefix': undefined,
                'number': undefined
            });
        }

        vm.deletePhones = function(index){
            vm.customerCorporate.phones.splice(index, 1)
        }
    }

    function deleteCustomerCorporateCtrl(linkService, customerCorporateService, customerCorporate, $uibModalInstance){
        var vm = this;
        vm.name = customerCorporate.data.socialReason;
        vm.linkService = linkService;

        vm.deleteCustomerCorporate = function(){
            customerCorporateService.deleteCustomerCorporate(linkService.getLinkId(customerCorporate.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function getCities(region, cityService, linkService, vm){
        if(region != undefined){

            cityService.getCitiesByRegion(linkService.getLinkId(region._links.self.href), true, true)
                .then(function(res){
                    vm.cities = res;
                });
        }else{
            vm.cities = [];
        }
    }

    function baseRateCustomerCorporateCtrl(linkService,baseRateCorporateService,$stateParams,customerCorporate, baseRates){
        var vm = this;
        vm.linkService = linkService;
        vm.customerCorporate = customerCorporate.data;
        vm.pages = baseRates.data.page;
        vm.baseRates = (baseRates.data._embedded)? baseRates.data._embedded.baserates : [];
        vm.editIndex = -1;
        vm.auxBaseRate = {};

        angular.forEach(vm.baseRates, function (baseRate) {
            baseRate.disabledClass = true;
            baseRate.showEdit = true;
            if(baseRate._embedded.baseratecorporate){
                baseRate._embedded.baseratecorporate.baseRateCorporateId = parseInt(linkService.getLinkId(baseRate._embedded.baseratecorporate._links.self.href));
                baseRate._embedded.baseratecorporate.baseRateId = parseInt(linkService.getLinkId(baseRate._links.self.href));
                baseRate._embedded.baseratecorporate.customerCorporateId = parseInt(linkService.getLinkId(vm.customerCorporate._links.self.href));
            }else{
                baseRate._embedded.baseratecorporate = {
                    baseRateCorporateId: undefined,
                    baseRateId: parseInt(linkService.getLinkId(baseRate._links.self.href)),
                    customerCorporateId: parseInt(linkService.getLinkId(vm.customerCorporate._links.self.href)),
                    tariffBasePassage: 0,
                    tariffBaseCargo: 0
                }
            }
        });

        vm.editBaseRateCorporate = function(index){
            vm.baseRates[index].disabledClass = false;
            vm.baseRates[index].showEdit = false;
            vm.editIndex = index;
            vm.auxBaseRate = angular.copy(vm.baseRates[index]);
        }

        vm.cancelBaseRateCorporate = function(index){
            vm.baseRates[index] = angular.copy(vm.auxBaseRate);
            vm.baseRates[index].disabledClass = true;
            vm.baseRates[index].showEdit = true;
            vm.editIndex = -1;
            vm.auxBaseRate = {};
        }

        vm.saveBaseRateCorporate = function(valid,index){
            if(valid){
                var saveBaseRateCorporate = vm.baseRates[index]._embedded.baseratecorporate;
                if(saveBaseRateCorporate.baseRateCorporateId==undefined){
                    baseRateCorporateService.saveBaseRateCorporate(saveBaseRateCorporate)
                        .then(function(res){
                            linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page, size: $stateParams.size, id: $stateParams.id});
                        });
                }else{
                    baseRateCorporateService.updateBaseRateCorporate(saveBaseRateCorporate.baseRateCorporateId, saveBaseRateCorporate)
                        .then(function(res){
                            linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page, size: $stateParams.size, id: $stateParams.id});
                        });
                }
            }
        }
    }

    function financialStateCustomerCorporateCtrl(linkService,kardexService,customerCorporate){
        var vm = this;
        vm.disableSelects = true;
        vm.linkService = linkService;
        vm.customerCorporate = customerCorporate.data;

        vm.customerCorporate.parent = vm.customerCorporate._embedded.customerCorporate;
        vm.customerCorporate.id = parseInt(linkService.getLinkId(vm.customerCorporate._links.self.href));
        vm.customerCorporate.centralOffice = ( vm.customerCorporate.id ==parseInt(vm.customerCorporate.parentId))?true:false;
        vm.customerCorporate.region = vm.customerCorporate._embeddeds.city._embedded.region;
        vm.customerCorporate.city = vm.customerCorporate._embeddeds.city;
        vm.balanceTotal = parseInt(vm.customerCorporate._embedded.kardex.balance);
        vm.hasError = false;
        vm.requiredWarning = "Valor debe ser menor o igual a lo adeudado.";

        vm.saveDeposit = function(isValid, customerCorporate){
            var valPrepaid = true;
            var valNegative = true;
            if (!customerCorporate.prepaid){
                if (vm.hasError===true){
                    valPrepaid=false;
                }
            }

            if (vm.customerCorporate.deposit<=0){
                valNegative=false;
            }

            if (isValid&&valPrepaid&&valNegative) {
                var kardex = {
                    "customerCorporateId": parseInt(linkService.getLinkId(vm.customerCorporate._links.self.href)),
                    "description": "DEPOSIT",
                    "have": vm.customerCorporate.deposit,
                    "should": "0"
                }
                kardexService.saveHave(kardex);
            }
        }

        vm.changeDeposit = function(prepaid) {
            if (vm.customerCorporate.deposit !== undefined) {
                vm.deposit = parseInt(vm.customerCorporate.deposit);
                if (prepaid) {
                    vm.customerCorporate._embedded.kardex.balance = vm.balanceTotal + vm.deposit;
                } else {
                    if (vm.deposit>vm.balanceTotal){
                        vm.deposit=vm.balanceTotal;
                        vm.hasError=true;
                    }else {
                        vm.customerCorporate._embedded.kardex.balance = vm.balanceTotal - vm.deposit;
                        vm.hasError=false;
                    }
                }
            } else {
                vm.customerCorporate._embedded.kardex.balance = vm.balanceTotal;
            }
        }
    }

    function getPhone(phones){
        var res = '';
        angular.forEach(phones, function(phone){
            res = res+(res.length==0?'':',')+phone.prefix+'-'+phone.number
        });
        return res;
    }

    function setPhones(phone){
        var res = [];
        angular.forEach(phone.split(','), function(splitPhone){
            res.push({
                'prefix': splitPhone.split('-')[0],
                'number': splitPhone.split('-')[1]
            });
        });
        return res;
    }
})();
